import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { ensure } from 'components/sharpr/ensure/ensure.js';

export function TrustedAuthAddEditRoute($stateProvider) {
	'ngInject';
	$stateProvider
		.state('hub.loggedin.TrustedAuthAdd', {
			url: '/admin/trusted_auth/add',
			controllerAs: 'vm',
			controller: TrustedAuthAddEditCtrl,
			templateUrl: '/ng/hub/TrustedAuth/AddEdit/TrustedAuthAddEditCtrl.html?' + window.BUILD,
			permission: ['all'],
			resolve: {
				$title: () => 'Add Trusted Auth',
				cred: () => {
					return {
						name: '',
						authType: '',
						authAccount: '',
						metadata: '',
						permissions: '',
					};
				},
			},
		})
		.state('hub.loggedin.TrustedAuthEdit', {
			url: '/admin/trusted_auth/:id/edit',
			controllerAs: 'vm',
			controller: TrustedAuthAddEditCtrl,
			templateUrl: '/ng/hub/TrustedAuth/AddEdit/TrustedAuthAddEditCtrl.html?' + window.BUILD,
			permission: ['all'],
			resolve: {
				$title: () => 'Edit Trusted Auth',
				cred: ApiResourcify.endpoint('/auth/trusted/:id'),
			},
		});
}

export class TrustedAuthAddEditCtrl {
	constructor(modal, Api, Identity, cred) {
		'ngInject';
		this.modal = modal;
		this.Api = Api;
		this.Identity = Identity;
		this.name = 'TrustedAuthAddEdit';
		this.types = [
			{ id: '', name: '' },
			{ id: 'trusted', name: 'Trusted' },
			{ id: 'account', name: 'Account' },
		];
		this.accounts = Identity.accountChoices();
		this.accounts.unshift({ id: '', $search: '' });
		// make sure you initialize your models so sh-select actually works!
		this.cred = ensure.object(cred);
	}

	save() {
		let method = 'post';
		let endpoint = '/auth/trusted';
		if (this.cred.id) {
			method = 'patch';
			endpoint += `/${this.cred.id}`;
		}
		this.Api[method](endpoint, this.cred).then(() => {
			this.$resolve();
		});
	}

	isAccountAuth() {
		return this.cred && this.cred.authType && this.cred.authType == 'account';
	}
}
